import { render, staticRenderFns } from "./UrgentenView.vue?vue&type=template&id=1243cf06&scoped=true&"
import script from "./UrgentenView.vue?vue&type=script&lang=js&"
export * from "./UrgentenView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1243cf06",
  null
  
)

export default component.exports